import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  Button,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  IconCopyMinus,
  IconGridDots,
  IconInvoice,
  IconSearch,
  IconCoin,
  IconPercentage,
  IconCurrencyDollar,
  IconArrowNarrowRight,
  IconPlus,
  IconTrash,
  IconLock,
  IconLockOpen2,
  IconArrowsUpDown,
} from "@tabler/icons-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useSelector } from "react-redux";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import {
  API_ENDPOINTS,
  handleKeyDown,
  truncateFormat,
  trimText,
  roundToMoney,
} from "../../constant/_constant";
import SearchPopUp from "./SearchPopUp";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";
import SearchPopUpSales from "./SearchPopUpSales";
import { useParams } from "react-router-dom";
import FbopPdfPopup from "./FbopPdfPopup";
import PdfProductsPopup from "./PdfProductsPopup";
import { trimTrailingZeros } from "../../utils/_helpers";

const TruncatedTooltip = ({ children }) => {
  const [show, setShow] = useState(false);
  const [text, setText] = useState("");

  const handleMouseEnter = (e) => {
    if (e.target.scrollWidth > e.target.clientWidth) {
      setText(e.target.value);
      setShow(true);
    }
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <OverlayTrigger
      placement="bottom"
      show={show}
      overlay={<Tooltip id="tooltip-truncated">{text}</Tooltip>}
    >
      {React.cloneElement(children, {
        onMouseEnter: (e) => {
          handleMouseEnter(e);
          if (children.props.onMouseEnter) children.props.onMouseEnter(e);
        },
        onMouseLeave: (e) => {
          handleMouseLeave(e);
          if (children.props.onMouseLeave) children.props.onMouseLeave(e);
        },
      })}
    </OverlayTrigger>
  );
};

function ProductsSales({ order_ref_type, isEditing, orderId }) {
  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  // const contractName = useSelector((state) => state.contract.contractName);
  const contractName = watch("contract_name");
  const textareaRef = useRef(null);
  const [dataSuggetion, setDataSuggetion] = useState([]);
  const [height, setHeight] = useState();
  const [shippingHide, setShippingHide] = useState(false);
  const [marginWarnings, setMarginWarnings] = useState({});
  const [vendorWarnings, setVendorWarnings] = useState({}); // New state for vendor warnings
  const [suggestionData, setSuggestionData] = useState([]);
  const [totalCostBeforeMargin, setTotalCostBeforeMargin] = useState("0.00");
  const [totalCostAfterMargin, setTotalCostAfterMargin] = useState("0.00");
  const [showModal, setShowModal] = useState(false);
  const [showFbopPopup, setShowFbopPopup] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [showSkuId, setShowSkuId] = useState(false);
  const [skuIds, setSkuIds] = useState([]);
  const hasSyncedInitialSkus = useRef(false);
  const [changeTracking, setChangeTracking] = useState({
    raw_sku_id: undefined,
    change_type: undefined,
  });
  const [showPdfProductsPopup, setShowPdfProductsPopup] = useState(false);
  const [selectedAutoId, setSelectedAutoId] = useState(null);

  const [searchProps, setSearchProps] = useState({
    searchSku: "",
    searchDescription: "",
    searchVendor: "",
    indexIs: "",
    ContractName: "",
    project_opportunity: "",
  });
  const { postData: fetchKitProduct, data: KitData } = usePostRequest(
    API_ENDPOINTS.GET_KIT_PRODUCT,
  );

  const { postData: fetchPurchaseData, data: PurchaseData } = usePostRequest(
    API_ENDPOINTS.GET_PURCHASE_DATA,
  );

  const { order_id } = useParams();

  // console.log("skuIdsskuIdsskuIds", skuIds);

  useEffect(() => {
    const currentOriginalVendors = getValues("originalVendors") || {};
    if (!getValues("originalVendors")) {
      setValue("originalVendors", {});
    }
  }, [getValues, setValue]);

  const [searchDebounces, setSearchDebounces] = useState({
    searchName: "",
  });

  const { data: vendors, postData: fetchVendors } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS,
  );

  const products = watch("product_sales");

  const appendSkuToArray = useCallback((product, qty = 1, rowId) => {
    const skuId = product?.sku_id;
    if (!skuId) return;

    console.log("productsproductsproducts", products);

    console.log("rowIdrowIdrowId", rowId);

    setSkuIds((prev) => [
      ...prev,
      {
        raw_sku_id: rowId,
        sku_id: skuId,
        type: product?.type || "",
        qty: qty,
        sku_display_name: product.sku_display_name,
        name: product.name,
        internal_id: product.vendor_sku || product?.internal_id,
        variant_id: product.variant_id || product?.Product?.variant_id,
        aspetto_price: product.aspetto_price,
        margin_percent: product.margin_percent,
        customer_price: product.customer_price,
        product_id: product?.Product?.id ?? product?.id,
        // product_id:
        //   searchType === "contract"
        //     ? product?.Product?.id
        //     : product?.id,
        vendor_id: product.Vendor?.id,
        display_name: product.Vendor?.display_name,
        description: product.description_sales,
      },
    ]);
  }, []);

  // const buildSalesProducts = (productSales) => {
  //   return productSales.map((product) => ({
  //     aspetto_price: Number(product.cost) || 0,
  //     margin_percent: Number(product.margin) || 0,
  //     customer_price: Number(product.customerCost) || 0,
  //   }));
  // };

  const buildSalesProducts = (productSales) => {
    return productSales?.map((product) => ({
      sku_id: product.skuIdUnique,
      qty: Number(product.qty) || 1,
      sku_display_name: product.skuId,
      name: product.productName,
      aspetto_price: Number(product.cost) || 0,
      margin_percent: Number(product.margin) || 0,
      customer_price: Number(product.customerCost) || 0,
      raw_sku_id: product.rowId,
      product_id: product.productId,
      vendor_id: product.vendorId,
      // type: product.type || null,
      display_name: product.vendorPartner,
      description: product.skuDescription,
    }));
  };

  // Auto-fetch purchase data when any SKU is added
  useEffect(() => {
    // const salesProduct = buildSalesProducts(products)
    // const purchaseProduct = buildSalesProducts(product_purchase);
    const purchaseProduct = buildSalesProducts(getValues("cards"));

    if (skuIds.length > 0) {
      fetchPurchaseData(
        {
          items: skuIds,
          module_type: "ORDER",
          order_id: isEditing ? orderId : 0,
          items_purchase: purchaseProduct,
          raw_sku_id: changeTracking.raw_sku_id,
          change_type: changeTracking.change_type,
          cv_rfq_id: cv_rfq_id,
          // sales_products: products,
          // items: salesProduct,
        },
        onSuccessPurchase,
        onErrorPurchase,
      );
      setChangeTracking({
        raw_sku_id: undefined,
        change_type: undefined,
      });
    }
  }, [skuIds]);

  const handleCostChange = (index, newCost) => {
    // setValue(`product_sales[${index}].cost`, newCost);
    // setTimeout(() => {
    //   triggerPurchaseDataFetch();
    // }, 300);
    const skuIdUnique = getValues(`product_sales[${index}].rowId`);
    if (!skuIdUnique) return;
    console.log("setSkuIdssetSkuIds", skuIds);
    console.log("skuIdUniqueskuIdUnique", skuIdUnique);

    // new added for tracking the cost change
    setChangeTracking({
      raw_sku_id: skuIdUnique,
      change_type: "cost",
    });

    setSkuIds((prev) =>
      prev.map((item) =>
        item.raw_sku_id === skuIdUnique
          ? { ...item, aspetto_price: Number(newCost) }
          : item,
      ),
    );
  };

  // const handleMarginChangeWithFetch = (index, marginValue) => {
  //   // setTimeout(() => {
  //   //   triggerPurchaseDataFetch();
  //   // }, 300);
  //   const skuIdUnique = getValues(`product_sales[${index}].rowId`);
  //   if (!skuIdUnique) return;
  //   console.log("setSkuIdssetSkuIds", skuIds);
  //   console.log("skuIdUniqueskuIdUnique", skuIdUnique);

  //   setSkuIds((prev) =>
  //     prev.map((item) =>
  //       item.raw_sku_id === skuIdUnique
  //         ? { ...item, margin_percent: Number(marginValue) }
  //         : item
  //     )
  //   );
  // };

  // const handleCustomerCostChange = (index, newCustomerCost) => {
  //   // setValue(`product_sales[${index}].customerCost`, newCustomerCost);
  //   // setTimeout(() => {
  //   //   triggerPurchaseDataFetch();
  //   // }, 300);
  //   const skuIdUnique = getValues(`product_sales[${index}].rowId`);
  //   if (!skuIdUnique) return;
  //   console.log("setSkuIdssetSkuIds", skuIds);
  //   console.log("skuIdUniqueskuIdUnique", skuIdUnique);

  //   setSkuIds((prev) =>
  //     prev.map((item) =>
  //       item.raw_sku_id === skuIdUnique
  //         ? { ...item, customer_price: Number(newCustomerCost) || 1 }
  //         : item
  //     )
  //   );
  // };

  // const handleDescriptionChange = (index, newDes) => {
  //   // setValue(`product_sales[${index}].cost`, newCost);
  //   // setTimeout(() => {
  //   //   triggerPurchaseDataFetch();
  //   // }, 300);
  //   const skuIdUnique = getValues(`product_sales[${index}].rowId`);
  //   if (!skuIdUnique) return;
  //   console.log("setSkuIdssetSkuIds", skuIds);
  //   console.log("skuIdUniqueskuIdUnique", skuIdUnique);

  //   setSkuIds((prev) =>
  //     prev.map((item) =>
  //       item.raw_sku_id === skuIdUnique
  //         ? { ...item, description: newDes }
  //         : item,
  //     ),
  //   );
  // };

  const handleDescriptionChange = (index, newDes) => {
    const skuIdUnique = getValues(`product_sales[${index}].rowId`);

    setSkuIds((prev) => {
      return prev.map((item) => {
        if (String(item.raw_sku_id) === String(skuIdUnique)) {
          return {
            ...item,
            description: newDes,
          };
        }

        return item;
      });
    });
  };

  // const triggerPurchaseDataFetch = useCallback(() => {
  //   if (skuIds.length > 0 && ordertype !== "M") {
  //     const products = getValues("product_sales") || [];
  //     const salesProducts = buildSalesProducts(products);

  //     fetchPurchaseData(
  //       {
  //         items: skuIds,
  //         module_type: "ORDER",
  //         order_id: isEditing ? orderId : 0,
  //         // items: salesProducts,
  //       },
  //       onSuccessPurchase,
  //       onErrorPurchase
  //     );
  //   }
  // }, [fetchPurchaseData, watch]);

  // Commented initial load api on sales tab
  useEffect(() => {
    // if (!order_id || hasSyncedInitialSkus.current) return;
    if (hasSyncedInitialSkus.current) return;

    const sales = getValues("product_sales") || [];

    const payload = sales
      .filter((it) => it.skuIdUnique)
      .map((it) => ({
        raw_sku_id: it.rowId,
        sku_id: it.skuIdUnique,
        type: it.type ?? "",
        qty: Number(it.qty) || 1,
        sku_display_name: it.skuId,
        internal_id: it.internalSku,
        variant_id: it.variantId,
        name: it.productName,
        aspetto_price: Number(it.cost),
        margin_percent: Number(it.margin),
        customer_price: Number(it.customerCost),
        product_id: it.productId,
        vendor_id: it.vendorId,
        display_name: it.vendorPartner,
        description: it.skuDescription,
      }));

    if (payload.length === 0) return;

    setSkuIds(payload);
    hasSyncedInitialSkus.current = true;
  }, []);

  const onSuccessPurchase = (res) => {
    const updatedProducts = res?.updatedProducts || [];

    // Build new cards array with updated data
    const newCards = updatedProducts.map((product) => ({
      vendorPartner: product?.Vendor?.display_name || "",
      skuId: product?.sku_display_name || "",
      skuIdUnique: product?.sku_id || "",
      productName: product?.name || "",
      skuDescription: product?.description || "",
      cost: product?.aspetto_price || 0,
      qty: product?.qty || 1,
      rowId: product?.raw_sku_id || "",
      variantId: product?.variant_id || "",
      internalSku: product?.internal_id || "",
      um: product?.uoi || "EA",
      margin: product?.margin_percent ?? 0,
      customerCost: product?.customer_price || 0,
      totalSkuCost: product?.total_price || 0,
      // auto_id: product?.auto_id ?? null,
      productId: product?.product_id ?? null,
      // kit_name: product?.parentKit?.name || product?.name,
      // kit_name:
      //   ordertype === "KIT" && product?.type === "kit"
      //     ? product?.parentKit?.name || product?.name
      //     : null,
      kit_name: product?.parentKit?.name,
      kit_raw_sku_id: product?.parentKit?.raw_sku_id,
    }));

    // FULLY REPLACE cards array
    setValue("cards", newCards, { shouldValidate: true });

    // Update originalVendorsPurchase map
    const initialOriginalVendorsPurchase = {};
    updatedProducts.forEach((product, index) => {
      initialOriginalVendorsPurchase[index] =
        product?.Vendor?.display_name || "";
    });
    setValue("originalVendorsPurchase", initialOriginalVendorsPurchase);
  };

  const onErrorPurchase = (err) => {
    console.log(err);
  };

  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin"];
  const isSuperAdmin = user?.roles?.some((role) => allowedRoles.includes(role));
  const isFinanceHead = user?.is_finance_department_head === true;
  const isDeptHead = user?.is_department_head;

  const order_status = getValues("orderStatus");

  const canEditProducts = (() => {
    return true; // Allow editing for all users regardless of role or order status
    if (!order_id) return true;

    if (order_status === "PENDING") return true;

    return isSuperAdmin || isDeptHead;
  })();

  useEffect(() => {
    if (searchDebounces?.searchName?.length > 0) {
      fetchVendors(
        {
          search:
            searchDebounces?.searchName?.length > 0
              ? searchDebounces?.searchName
              : undefined,
        },
        onSuggestionSuccessData,
      );
    }
  }, [searchDebounces]);

  const onSuggestionSuccessData = (data) => {
    setSuggestionData(data);
  };

  const handleSearchByName = (e) => {
    setSearchDebounces({ searchName: e.target.value });
  };

  const handleSelectVendor = (item, index) => {
    const currentVendorPartner = getValues(
      `product_sales[${index}].vendorPartner`,
    );
    const originalVendors = getValues("originalVendors") || {};
    const originalVendor = originalVendors[index];
    const newVendor = item?.display_name;

    // Check if this is a change from the original product vendor
    if (originalVendor && originalVendor !== newVendor) {
      setVendorWarnings((prevWarnings) => ({
        ...prevWarnings,
        [index]: true,
      }));
      console.log(`Vendor changed for card ${index}:`, {
        original: originalVendor,
        new: newVendor,
        productSku: getValues(`product_sales[${index}].skuId`),
      });
    } else {
      setVendorWarnings((prevWarnings) => {
        const updated = { ...prevWarnings };
        delete updated[index];
        return updated;
      });
    }

    setValue(`product_sales[${index}].vendorPartner`, newVendor, {
      shouldValidate: true,
    });

    // Clear suggestions
    setSuggestionData([]);
    setSearchDebounces({ searchName: "" });
  };

  const ordertype = watch("ordertype");
  const project_opportunity_id = watch("ProjectID");

  // const onSuccessDataKit = (res) => {
  //   console.log("kit ka res h", res.data);

  //   const existingCards = getValues("cards") || [];
  //   const currentOriginalVendors = getValues("originalVendorsPurchase") || {};

  //   // ---------------------------------------------------------------
  //   // 0. Get the *triggering* product from product_sales (the last added one)
  //   // ---------------------------------------------------------------
  //   const productSales = getValues("product_sales") || [];
  //   const lastAddedProduct = productSales[productSales.length - 1];

  //   // ---------------------------------------------------------------
  //   // 1. Map existing SKUs (unique) → index in cards array
  //   // ---------------------------------------------------------------
  //   const skuToIndex = new Map();
  //   existingCards.forEach((card, idx) => {
  //     if (card.skuIdUnique) {
  //       skuToIndex.set(card.skuIdUnique, idx);
  //     }
  //   });

  //   // ---------------------------------------------------------------
  //   // 2. Handle EMPTY KIT RESPONSE → append the kit itself
  //   // ---------------------------------------------------------------
  //   const incoming = res?.data ?? [];
  //   const newCards = [];
  //   let nextNewIndex = existingCards.length;

  //   if (incoming.length === 0) {
  //     // EMPTY KIT → treat the kit product as a standalone item
  //     const sku = lastAddedProduct.skuIdUnique;

  //     if (skuToIndex.has(sku)) {
  //       // Already exists → just increase qty
  //       const idx = skuToIndex.get(sku);
  //       const oldQty = Number(existingCards[idx].qty) || 0;
  //       const newQty = oldQty + 1;
  //       const cost = Number(existingCards[idx].cost) || 0;
  //       const totalSkuCost = (cost * newQty).toFixed(2);

  //       setValue(`cards[${idx}].qty`, newQty, { shouldValidate: true });
  //       setValue(`cards[${idx}].totalSkuCost`, totalSkuCost, {
  //         shouldValidate: true,
  //       });
  //     } else {
  //       // New card: use data from product_sales (the kit)
  //       currentOriginalVendors[nextNewIndex] =
  //         lastAddedProduct.vendorPartner || "";
  //       newCards.push({
  //         vendorPartner: lastAddedProduct.vendorPartner || "",
  //         skuId: lastAddedProduct.skuId || "",
  //         skuIdUnique: lastAddedProduct.skuIdUnique || "",
  //         skuDescription: lastAddedProduct.skuDescription || "",
  //         cost: lastAddedProduct.cost || 0,
  //         qty: 1,
  //         margin: lastAddedProduct.margin ?? 0,
  //         customerCost: lastAddedProduct.customerCost || 0,
  //         um: lastAddedProduct.um || "EA",
  //         totalSkuCost: lastAddedProduct.customerCost || 0,
  //         auto_id: lastAddedProduct.auto_id ?? null,
  //         product_id: lastAddedProduct.product_id ?? null,
  //       });
  //       nextNewIndex++;
  //     }
  //   }
  //   // ---------------------------------------------------------------
  //   // 3. Handle NON-EMPTY KIT → normal explode logic
  //   // ---------------------------------------------------------------
  //   else {
  //     incoming.forEach((kitItem) => {
  //       const sku = kitItem.sku_id;

  //       if (skuToIndex.has(sku)) {
  //         const idx = skuToIndex.get(sku);
  //         const oldQty = Number(existingCards[idx].qty) || 0;
  //         const addQty = Number(kitItem.quantity) || 0;
  //         const newQty = oldQty + addQty;
  //         const cost = Number(existingCards[idx].cost) || 0;
  //         const totalSkuCost = (cost * newQty).toFixed(2);

  //         setValue(`cards[${idx}].qty`, newQty, { shouldValidate: true });
  //         setValue(`cards[${idx}].totalSkuCost`, totalSkuCost, {
  //           shouldValidate: true,
  //         });
  //       } else {
  //         currentOriginalVendors[nextNewIndex] =
  //           kitItem.Vendor?.display_name || "";
  //         newCards.push({
  //           vendorPartner: kitItem.Vendor?.display_name || "",
  //           skuId: kitItem.sku_display_name || "",
  //           skuIdUnique: kitItem.sku_id || "",
  //           skuDescription: kitItem.description || "",
  //           cost: kitItem.aspetto_price || 0,
  //           qty: kitItem.quantity || 1,
  //           margin: kitItem.margin_percent ?? 0,
  //           customerCost: kitItem.customer_price || 0,
  //           um: kitItem.unit_of_measure || kitItem.uoi || "EA",
  //           totalSkuCost: kitItem.total_price || 0,
  //           auto_id: kitItem.auto_id ?? null,
  //           product_id: kitItem.product_id ?? null,
  //         });
  //         nextNewIndex++;
  //       }
  //     });
  //   }

  //   // ---------------------------------------------------------------
  //   // 4. Append only truly new cards
  //   // ---------------------------------------------------------------
  //   if (newCards.length > 0) {
  //     const combined = [...existingCards, ...newCards];
  //     setValue("cards", combined, { shouldValidate: true });
  //   }

  //   // ---------------------------------------------------------------
  //   // 5. Persist original vendors map
  //   // ---------------------------------------------------------------
  //   setValue("originalVendorsPurchase", currentOriginalVendors);

  //   // ---------------------------------------------------------------
  //   // 6. Re-calculate totals
  //   // ---------------------------------------------------------------
  //   setTimeout(() => calculateCosts(), 0);
  // };

  // const onSuccessDataKit = (res) => {
  //   // console.log("kit ka res h", res);
  //   const existingCards = getValues("cards") || [];

  //   const existingSkuIds = new Set(
  //     existingCards.map((card) => card.skuIdUnique)
  //   );
  //   // console.log("existingSkuIds", existingSkuIds);
  //   // console.log("res data", res?.data);
  //   const currentOriginalVendors = getValues("originalVendorsPurchase") || {};
  //   const updatedSales = (res?.data ?? [])
  //     .filter((card) => !existingSkuIds.has(card.sku_id)) // Filter out duplicates
  //     .map((card, idx) => {
  //       const cardIndex = existingCards.length + idx; // Final index in combined array

  //       // Store original vendor name by index (for warning logic)
  //       currentOriginalVendors[cardIndex] = card.Vendor?.display_name || "";

  //       return {
  //         vendorPartner: card.Vendor?.display_name || "",
  //         skuId: card.sku_display_name || "",
  //         skuIdUnique: card.sku_id || "",
  //         skuDescription: card.description || "",
  //         cost: card.aspetto_price || 0,
  //         qty: card.quantity || 1,
  //         margin: card.margin_percent ?? 0,
  //         customerCost: card.customer_price || 0,
  //         um: card.unit_of_measure || card.uoi || "EA",
  //         totalSkuCost: card.total_price || 0,

  //         // Optional: keep if needed elsewhere
  //         auto_id: card.auto_id ?? null,
  //         product_id: card.product_id ?? null,
  //       };
  //     });

  //   const combinedCards = [...existingCards, ...updatedSales];
  //   setValue("cards", combinedCards, { shouldValidate: true });
  // };

  useEffect(() => {
    const hasKitData = KitData?.data && KitData.data.length > 0;
    setValue("hasKitProducts", hasKitData, { shouldValidate: false });
  }, [KitData, setValue]);

  const syncProductSalesWithCards = () => {
    // console.log("YE SYNC CHALA");
    const latestCards = getValues("product_sales") || [];
    const isKitOrder =
      ordertype === "CRK" ||
      ordertype === "DS" ||
      ordertype === "KIT" ||
      ordertype === "S";
    const hasValidSkus =
      Array.isArray(latestCards) &&
      latestCards.length > 0 &&
      latestCards.every((item) => item.skuId && item.skuId.trim() !== "");
    if (isKitOrder && hasValidSkus) {
      const payload = {
        module_type: "ORDER",
        product_id: latestCards[latestCards.length - 1].skuIdUnique,
      };
      // fetchKitProduct(payload, onSuccessDataKit);
    }

    // if ((ordertype === "DS" || ordertype === "M") && latestCards.length > 0) {
    //   const updatedSales = latestCards.map((card) => ({
    //     vendorPartner: card.vendorPartner || "",
    //     skuId: card.skuId || "",
    //     skuDescription: card.skuDescription || "",
    //     cost: card.cost || 0,
    //     qty: card.qty || 1,
    //     margin: card.margin ?? 0,
    //     customerCost: card.customerCost || 0,
    //     um: card.um || "",
    //     totalSkuCost: card.totalSkuCost || 0,
    //   }));
    //   setValue("cards", updatedSales, { shouldValidate: true });
    // }

    // const cardData = getValues("cards");
    // console.log("cardData after updating in sales", cardData);
  };

  const handleOpenModal = (index, type) => {
    if (index === null && type === "skuAll") {
      setSearchType(type);
      const currentCards = getValues("product_sales");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );

      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          project_opportunity: project_opportunity_id,
          indexIs: undefined,
        });
      }
      // setSearchProps({
      //   searchSku: "",
      //   searchDescription: "",
      //   searchVendor: "",
      // });
    } else if (index === null && type === "contract") {
      setSearchType(type);
      const currentCards = getValues("product_sales");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );

      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: undefined,
        });
      }

      // setSearchProps({
      //   searchSku: "",
      //   searchDescription: "",
      //   searchVendor: "",
      //   ContractName: contractName,
      // });
    } else {
      const { vendor, sku, description } = cardSearch[index];
      setSearchProps({
        searchSku: sku,
        searchDescription: description,
        searchVendor: vendor,
        indexIs: index,
      });
    }
    setShowModal(true);
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "product_sales",
  });

  const {
    fields: otherCostFields,
    append: appendOtherCost,
    remove: removeOtherCost,
  } = useFieldArray({
    control,
    name: "other_cost_json_sales",
  });

  const handleAddOtherCost = () => {
    appendOtherCost({
      Name: "",
      Amount: "",
    });
  };

  const generateUniqueId10 = () => {
    const array = new Uint8Array(8);
    crypto.getRandomValues(array);

    const id = btoa(String.fromCharCode(...array))
      .replace(/[^a-zA-Z0-9]/g, "")
      .slice(0, 10);

    // console.log("Generated ID:", id);
    return id;
  };

  const handleAddCard = () => {
    const newIndex = cardFields.length;
    const rowId = generateUniqueId10();
    appendCard({
      vendorPartner: "",
      skuId: "",
      skuDescription: "",
      type: "",
      productId: "",
      vendorId: "",
      internalSku: "",
      variantId: "",
      productName: "",
      rowId: rowId,
      prodDescription: "",
      qty: 1,
      um: "EA",
      cost: "",
      margin: 0,
      customerCost: "",
      totalSkuCost: "",
      clin: "",
    });

    setVendorWarnings((prev) => {
      const updated = { ...prev };
      delete updated[newIndex];
      return updated;
    });
    const currentOriginalVendors = getValues("originalVendors") || {};
    setValue("originalVendors", {
      ...currentOriginalVendors,
      [newIndex]: undefined, // Initialize with undefined for new card
    });
    // calculateCosts();
  };

  const contractVehicletype = watch("contractVehicletype");
  const cv_rfq_id = watch("cv_rfq_id");

  const handleAddSku = (product) => {
    // console.log("product ye waala h", product);

    const currentValues = getValues("cards") || [];
    const newIndex = currentValues.length;

    // Set the original vendor for the new card
    const currentOriginalVendors = getValues("originalVendors") || {};
    setValue("originalVendors", {
      ...currentOriginalVendors,
      [newIndex]: product?.Vendor?.display_name,
    });

    // Clear any vendor warning for the new card
    setVendorWarnings((prev) => {
      const updated = { ...prev };
      delete updated[newIndex];
      return updated;
    });

    const isProductBound = contractVehicletype
      ?.split(",")
      .includes("product-bound");

    const rowId = generateUniqueId10();
    console.log("generateUniqueId10", rowId);
    if (isProductBound) {
      appendSkuToArray(product, 1, product?.raw_sku_id);
    } else {
      appendSkuToArray(product, 1, rowId);
    }

    const effectiveRowId = isProductBound ? product?.raw_sku_id : rowId;
    if (product?.customer_price === "0.00") {
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        vendorId: product?.Vendor?.id,
        productId:
          searchType === "contract" ? product?.Product?.id : product?.id,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description_sales,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || product?.Product?.variant_id || "",
        prodDescription: product?.description,
        productName: product?.name,
        type: product?.type,
        qty: 1,
        um: "EA",
        rowId: effectiveRowId,
        cost: trimTrailingZeros(product?.aspetto_price),
        margin: 8,
        clin: product?.clin_id,
        // customerCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
        // customerCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        customerCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        // totalSkuCost: product?.aspetto_price,

        // totalSkuCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
        // totalSkuCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        totalSkuCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        ...(isProductBound && {
          max_quantity: product?.max_quantity ?? 0,
        }),
      });
      console.log("this case ran");
    } else {
      const margin =
        ((product?.customer_price - product?.aspetto_price) /
          product?.customer_price) *
        100;
      console.log("calculatedmargin", margin);
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        vendorId: product?.Vendor?.id,
        productId:
          searchType === "contract" ? product?.Product?.id : product?.id,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description_sales,
        internalSku: product?.internal_id || product?.vendor_sku || "",
        variantId: product?.variant_id || product?.Product?.variant_id || "",
        prodDescription: product?.description,
        type: product?.type,
        productName: product?.name,
        clin: product?.clin_id,
        qty: 1,
        um: "EA",
        rowId: effectiveRowId,
        cost: trimTrailingZeros(product?.aspetto_price),
        // margin: parseFloat(margin.toFixed(2)),
        margin: truncateFormat(margin, 4),
        customerCost: product?.customer_price,
        totalSkuCost: product?.customer_price,
        ...(isProductBound && {
          max_quantity: product?.max_quantity ?? 0,
        }),
      });
      console.log("this case ran else");
    }
    syncProductSalesWithCards();
    calculateCosts();
    toast.success(`Product ${product.sku_display_name} is added successfully`);
  };

  const handleAddSkuBulk = (products) => {
    const currentSalesLength = getValues("product_sales")?.length || 0;
    const currentOriginalVendors = getValues("originalVendors") || {};
    const newSkuEntries = [];

    products.forEach((product, i) => {
      const rowId = generateUniqueId10();
      const newIndex = currentSalesLength + i;

      // Initialize originalVendors entry (no vendor object in this response)
      currentOriginalVendors[newIndex] = undefined;

      // Collect all sku entries in one batch for setSkuIds
      newSkuEntries.push({
        raw_sku_id: rowId,
        sku_id: product.sku_id,
        type: product.type || "",
        qty: product?.quantity,
        sku_display_name: product.sku_display_name,
        name: product.name,
        aspetto_price: Number(product.aspetto_price),
        margin_percent: Number(product.margin_percent),
        customer_price: Number(product.customer_price),
        product_id: product.id,
        vendor_id: product.vendor_id,
        display_name: product.Vendor?.display_name,
        description: product.description_sales,
      });

      // Mirror handleAddSku's customer_price === "0.00" branch
      if (product.customer_price === "0.00") {
        appendCard({
          vendorPartner: product.Vendor?.display_name,
          vendorId: product.vendor_id,
          productId: product.id,
          skuId: product.sku_display_name,
          skuIdUnique: product.sku_id,
          skuDescription: product.description_sales,
          prodDescription: product.description,
          productName: product.name,
          internalSku: product?.internal_id || product?.vendor_sku || "",
          variantId: product?.variant_id || "",
          type: product.type,
          qty: product?.quantity,
          um: product.uoi || "EA",
          rowId,
          cost: product.aspetto_price,
          margin: 8,
          clin: "",
          // customerCost: truncateFormat(
          //   Number(product.aspetto_price) / (1 - 8 / 100),
          //   2,
          // ),
          customerCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),

          // totalSkuCost: truncateFormat(
          //   Number(product.aspetto_price) / (1 - 8 / 100),
          //   2,
          // ),
          totalSkuCost: roundToMoney(product?.aspetto_price / (1 - 8 / 100)),
        });
      } else {
        const margin =
          ((Number(product.customer_price) - Number(product.aspetto_price)) /
            Number(product.customer_price)) *
          100;
        appendCard({
          vendorPartner: product.Vendor?.display_name,
          vendorId: product.vendor_id,
          productId: product.id,
          skuId: product.sku_display_name,
          skuIdUnique: product.sku_id,
          skuDescription: product.description_sales,
          prodDescription: product.description,
          productName: product.name,
          internalSku: product?.internal_id || product?.vendor_sku || "",
          variantId: product?.variant_id || "",
          type: product.type,
          qty: product?.quantity,
          um: product.uoi || "EA",
          rowId,
          cost: product.aspetto_price,
          margin: truncateFormat(margin, 4),
          clin: "",
          customerCost: product.customer_price,
          totalSkuCost: product.customer_price,
        });
      }
    });

    // Single state updates after the loop — avoids stale closure issues
    setValue("originalVendors", currentOriginalVendors);
    setSkuIds((prev) => [...prev, ...newSkuEntries]);
    calculateCosts();
    toast.success(`${products.length} product(s) added successfully`);
  };

  const handleLockUnLock = (e, index, type) => {
    e.stopPropagation();
  };

  useEffect(() => {
    const existingCards = getValues("product_sales");
    const rowId = generateUniqueId10();
    if (!existingCards || existingCards.length === 0) {
      appendCard({
        vendorPartner: "",
        skuId: "",
        productId: "",
        type: "",
        vendorId: "",
        skuDescription: "",
        internalSku: "",
        variantId: "",
        purchaseDescription: "",
        qty: 1,
        productName: "",
        um: "EA",
        rowId: rowId,
        cost: "",
        margin: 0,
        customerCost: "",
        totalSkuCost: "",
        clin: "",
      });
    }
  }, [appendCard, getValues]);

  const handleRemoveCard = (index) => {
    if (cardFields.length > 1) {
      // Remove warnings for the deleted card
      setMarginWarnings((prev) => {
        const updated = { ...prev };
        delete updated[index];
        // Reindex warnings to match new card indices
        const reindexed = {};
        Object.keys(updated).forEach((key) => {
          const oldIndex = parseInt(key);
          if (oldIndex > index) {
            reindexed[oldIndex - 1] = updated[oldIndex];
          } else if (oldIndex < index) {
            reindexed[oldIndex] = updated[oldIndex];
          }
        });
        return reindexed;
      });

      setVendorWarnings((prev) => {
        const updated = { ...prev };
        delete updated[index];
        // Reindex warnings to match new card indices
        const reindexed = {};
        Object.keys(updated).forEach((key) => {
          const oldIndex = parseInt(key);
          if (oldIndex > index) {
            reindexed[oldIndex - 1] = updated[oldIndex];
          } else if (oldIndex < index) {
            reindexed[oldIndex] = updated[oldIndex];
          }
        });
        return reindexed;
      });

      // Remove and reindex originalVendors
      const currentOriginalVendors = getValues("originalVendors") || {};
      const updatedOriginalVendors = {};
      Object.keys(currentOriginalVendors).forEach((key) => {
        const oldIndex = parseInt(key);
        if (oldIndex !== index) {
          const newIndex = oldIndex > index ? oldIndex - 1 : oldIndex;
          updatedOriginalVendors[newIndex] = currentOriginalVendors[oldIndex];
        }
      });
      setValue("originalVendors", updatedOriginalVendors);

      const removedSkuIdUnique = getValues(`product_sales[${index}].rowId`);
      console.log("removedSkuIdUnique", removedSkuIdUnique);
      if (removedSkuIdUnique) {
        setSkuIds((prev) =>
          prev.filter((item) => item.raw_sku_id !== removedSkuIdUnique),
        );
      }

      removeCard(index);
      setTimeout(() => {
        const updatedCards = getValues("cards");
        calculateCosts(updatedCards);
      }, 0);
    }
  };

  // console.log("the change inn products", getValues("product_sales"));

  // const handleRemoveCard = (index) => {
  //   const currentCards = getValues("product_sales");
  //   if (cardFields.length > 1) {
  //     removeCard(index);
  //     setTimeout(() => {
  //       const updatedCards = getValues("product_sales");
  //       calculateCosts(updatedCards);
  //     }, 0);
  //   }
  // };

  const handleRemoveOthercost = (index) => {
    const currentOthercost = getValues("other_cost_json_sales");
    if (otherCostFields.length > 0) {
      removeOtherCost(index);
      setTimeout(() => {
        const updatedOthercost = getValues("other_cost_json_sales");
        calculateCosts(updatedOthercost);
      }, 0);
    }
  };

  const handleDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination || destination.index === source.index) return;
    const currentValues = getValues("product_sales");
    const reorderedCards = [...currentValues];
    const [removed] = reorderedCards.splice(source.index, 1);
    reorderedCards.splice(destination.index, 0, removed);
    setValue("product_sales", reorderedCards);

    // Reorder originalVendors to match the new card order
    const currentOriginalVendors = getValues("originalVendors") || {};
    const reorderedOriginalVendors = {};
    Object.keys(currentOriginalVendors).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedOriginalVendors[newIndex] = currentOriginalVendors[oldIndex];
    });
    setValue("originalVendors", reorderedOriginalVendors);

    // Reorder marginWarnings
    const reorderedMarginWarnings = {};
    Object.keys(marginWarnings).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedMarginWarnings[newIndex] = marginWarnings[oldIndex];
    });
    setMarginWarnings(reorderedMarginWarnings);

    // Reorder vendorWarnings
    const reorderedVendorWarnings = {};
    Object.keys(vendorWarnings).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedVendorWarnings[newIndex] = vendorWarnings[oldIndex];
    });
    setVendorWarnings(reorderedVendorWarnings);
  };

  // const handleDragEnd = (result) => {
  //   const { destination, source } = result;
  //   if (!destination || destination.index === source.index) return;
  //   const currentValues = getValues("product_sales");
  //   const reorderedCards = [...currentValues];
  //   const [removed] = reorderedCards.splice(source.index, 1);
  //   reorderedCards.splice(destination.index, 0, removed);
  //   setValue("product_sales", reorderedCards);
  // };

  // const calculateCosts = (name) => {
  //   let currentfield = "";
  //   let currentindex = null;
  //   if (typeof name === "string") {
  //     const pathParts = name.match(/product_sales\[(\d+)\]\.(\w+)/);
  //     ////  let currentindex = pathParts ? parseInt(pathParts[1]) : null;
  //     currentindex = pathParts ? parseInt(pathParts[1]) : null;
  //     currentfield = pathParts ? pathParts[2] : null;
  //   }

  //   let totalBeforeMarginSales = 0;
  //   let totalAfterMarginSales = 0;

  //   const product_sales = getValues("product_sales") || [];

  //   const other_cost_json_sales = getValues("other_cost_json_sales") || [];

  //   const shippingCostsales = parseFloat(getValues("shippingCostsales")) || 0;
  //   const taxsales = parseFloat(getValues("taxsales")) || 0;

  //   product_sales?.forEach((card, index) => {

  //     if (currentfield !== "" && currentindex !== null && currentindex !== index) {
  //       // This card didn't change - just add its totals
  //       totalBeforeMarginSales += parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
  //       totalAfterMarginSales += parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
  //       return; // Skip recalculation for this card
  //     }

  //     if (currentfield != "" && currentindex === index) {
  //       const customerCostLock = card.customerCostLock;
  //       const costLock = card.CostLock;
  //       const marginLock = card.marginLock;

  //       const qty = parseFloat(card.qty) || 0;
  //       let cost = parseFloat(card.cost) || 0;
  //       let margin = parseFloat(card.margin) || 0;
  //       let customerCost = parseFloat(card.customerCost) || 0;
  //       let totalSkuCost = 0;
  //       const lockFields = ["customerCostLock", "CostLock", "marginLock"];

  //       if (lockFields.includes(currentfield)) {
  //         return;
  //       }

  //       if (
  //         customerCostLock == false &&
  //         costLock == false &&
  //         marginLock == false
  //       ) {
  //         if (currentfield == "customerCost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           if (cost == 0) {
  //             margin = 0;
  //             setValue(
  //               `product_sales[${product_sales.indexOf(card)}].cost`,
  //               truncateFormat(totalSkuCost, 2)
  //             );
  //           } else {
  //             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           }
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].margin`,
  //           //   margin.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         } else {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].customerCost`,
  //           //   customerCost.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         }
  //       } else if (customerCostLock == true) {
  //         if (currentfield == "cost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].margin`,
  //           //   margin.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         } else if (currentfield == "margin") {
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // margin
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].cost`,
  //           //   cost.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         }
  //       } else if (marginLock == true) {
  //         if (currentfield == "cost") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].customerCost`,
  //           //   customerCost.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         } else if (currentfield == "customerCost") {
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           // customer cost
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].cost`,
  //           //   cost.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         }
  //       } else if (costLock == true) {
  //         if (currentfield == "margin") {
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].customerCost`,
  //           //   customerCost.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         } else {
  //           // customer cost change , need to calculate margin
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);

  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].margin`,
  //           //   margin.toFixed(2)
  //           // );
  //           // setValue(
  //           //   `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         }
  //       }

  //       totalBeforeMarginSales += cost * qty;
  //       totalAfterMarginSales += parseFloat(totalSkuCost);
  //     } else {
  //       totalBeforeMarginSales += parseFloat(card.cost * card.qty);
  //       totalAfterMarginSales += parseFloat(card.customerCost * card.qty);
  //     }
  //   });

  //   // Calculate costs for each other cost
  //   other_cost_json_sales?.forEach((costItem) => {
  //     const amount = parseFloat(costItem.Amount) || 0;
  //     if (amount > 0) {
  //       totalBeforeMarginSales += parseFloat(amount);
  //       totalAfterMarginSales += parseFloat(amount);
  //     }
  //   });

  //   if (shippingCostsales > 0) {
  //     totalBeforeMarginSales += parseFloat(shippingCostsales);
  //     totalAfterMarginSales += parseFloat(shippingCostsales);
  //   }

  //   // Add tax if enabled
  //   if (taxsales > 0) {
  //     totalBeforeMarginSales += parseFloat(taxsales);
  //     totalAfterMarginSales += parseFloat(taxsales);
  //   }

  //   // Set the final values
  //   // setTotalCostBeforeMargin(parseFloat(totalBeforeMarginSales).toFixed(2));
  //   // setTotalCostAfterMargin(parseFloat(totalAfterMarginSales).toFixed(2));

  //   setTotalCostBeforeMargin(truncateFormat(totalBeforeMarginSales, 2));
  //   setTotalCostAfterMargin(truncateFormat(totalAfterMarginSales, 2));

  //   // Update form state
  //   setValue(
  //     "totalCostBeforeMarginSales",
  //     truncateFormat(totalBeforeMarginSales, 2)
  //   );
  //   setValue(
  //     "totalCostAfterMarginSales",
  //     truncateFormat(totalAfterMarginSales, 2)
  //   );
  //   // setValue(
  //   //   "totalCostBeforeMarginSales",
  //   //   parseFloat(totalBeforeMarginSales).toFixed(2)
  //   // );
  //   // setValue(
  //   //   "totalCostAfterMarginSales",
  //   //   parseFloat(totalAfterMarginSales).toFixed(2)
  //   // );
  // };

  const computeCustomerCost = (cost, margin) =>
    parseFloat(margin) === 0 ? 0 : cost / (1 - margin / 100);

  const computeMargin = (cost, customerCost) =>
    parseFloat(customerCost) === 0
      ? 0
      : ((customerCost - cost) / customerCost) * 100;

  const calculateCosts = (name) => {
    let currentfield = "";
    let currentindex = null;
    if (typeof name === "string") {
      const pathParts = name.match(/product_sales\[(\d+)\]\.(\w+)$/);
      currentindex = pathParts ? parseInt(pathParts[1]) : null;
      currentfield = pathParts ? pathParts[2] : null;
    }

    let totalBeforeMarginSales = 0;
    let totalAfterMarginSales = 0;

    const product_sales = getValues("product_sales") || [];

    const other_cost_json_sales = getValues("other_cost_json_sales") || [];

    const shippingCostsales = parseFloat(getValues("shippingCostsales")) || 0;
    const taxsales = parseFloat(getValues("taxsales")) || 0;

    product_sales?.forEach((card, index) => {
      setValue(
        `product_sales[${index}].purchaseCost`,
        roundToMoney(
          (parseFloat(card.cost) || 0) * (parseFloat(card.qty) || 0),
        ),
      );
      if (
        currentfield !== "" &&
        currentindex !== null &&
        currentindex !== index
      ) {
        // This card didn't change - just add its totals
        totalBeforeMarginSales +=
          parseFloat(card.cost || 0) * parseFloat(card.qty || 0);
        totalAfterMarginSales +=
          parseFloat(card.customerCost || 0) * parseFloat(card.qty || 0);
        return; // Skip recalculation for this card
      }

      if (currentfield != "" && currentindex === index) {
        const customerCostLock = card.customerCostLock;
        const costLock = card.CostLock;
        const marginLock = card.marginLock;

        const qty = parseFloat(card.qty) || 0;
        let cost = parseFloat(card.cost) || 0;
        let margin = parseFloat(card.margin) || 0;
        let customerCost = parseFloat(card.customerCost) || 0;
        let totalSkuCost = 0;
        const lockFields = ["customerCostLock", "CostLock", "marginLock"];

        console.log("currentfieldcurrentfield", currentfield);

        if (lockFields.includes(currentfield)) {
          return;
        }

        if (
          customerCostLock == false &&
          costLock == false &&
          marginLock == false
        ) {
          if (currentfield == "customerCost") {
            // margin = parseFloat(((customerCost - cost) / customerCost) * 100);
            margin = computeMargin(cost, customerCost);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            if (cost == 0) {
              margin = 0;
              setValue(
                `product_sales[${product_sales.indexOf(card)}].cost`,
                roundToMoney(totalSkuCost),
              );
            } else {
              // margin = parseFloat(((customerCost - cost) / customerCost) * 100);
              margin = computeMargin(cost, customerCost);
            }
            setValue(
              `product_sales[${product_sales.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            // customerCost = cost / (1 - margin / 100);
            customerCost = computeCustomerCost(cost, margin);
            console.log("customerCost 1", customerCost);
            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);

            console.log("roundedCustomerCost 1", roundedCustomerCost);

            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (customerCostLock == true) {
          if (currentfield == "cost") {
            // margin = parseFloat(((customerCost - cost) / customerCost) * 100);
            margin = computeMargin(cost, customerCost);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "margin") {
            const costCust = customerCost * (1 - margin / 100);

            console.log("customerCost 2", customerCost);
            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            // customerCost = cost / (1 - margin / 100);
            customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].cost`,
              roundToMoney(cost),
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (marginLock == true) {
          if (currentfield == "cost") {
            // customerCost = cost / (1 - margin / 100);
            customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "customerCost") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            // customerCost = cost / (1 - margin / 100);
            customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            console.log("customerCost 3", customerCost);
            setValue(
              `product_sales[${product_sales.indexOf(card)}].cost`,
              roundToMoney(cost),
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (costLock == true) {
          if (currentfield == "margin") {
            // customerCost = cost / (1 - margin / 100);
            customerCost = computeCustomerCost(cost, margin);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            // margin = parseFloat(((customerCost - cost) / customerCost) * 100);
            margin = computeMargin(cost, customerCost);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `product_sales[${product_sales.indexOf(card)}].margin`,
              roundToMoney(margin, 4),
            );
            setValue(
              `product_sales[${product_sales.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        }

        totalBeforeMarginSales += cost * qty;
        totalAfterMarginSales += parseFloat(totalSkuCost);

        // const skuIdUnique = getValues(`product_sales[${index}].rowId`);
        // if (!skuIdUnique) return;
        // console.log("marginmargin", margin);
        // console.log("customerCostcustomerCost", customerCost);
        // console.log("costcost", cost)

        // setSkuIds((prev) =>
        //   prev.map((item) =>
        //     item.raw_sku_id === skuIdUnique
        //       ? {
        //         ...item,
        //         aspetto_price: Number(roundToMoney(cost)),
        //         margin_percent: Number(roundToMoney(margin)),
        //         customer_price: Number(roundToMoney(customerCost)),
        //       }
        //       : item
        //   )
        // );
      } else {
        totalBeforeMarginSales += parseFloat(card.cost * card.qty);
        totalAfterMarginSales += parseFloat(card.customerCost * card.qty);
      }
    });

    // Calculate costs for each other cost
    other_cost_json_sales?.forEach((costItem) => {
      const amount = parseFloat(costItem.Amount) || 0;
      if (amount > 0) {
        // totalBeforeMarginSales += parseFloat(amount);
        totalAfterMarginSales += parseFloat(amount);
      }
    });

    if (shippingCostsales > 0) {
      // totalBeforeMarginSales += parseFloat(shippingCostsales);
      totalAfterMarginSales += parseFloat(shippingCostsales);
    }

    // Add tax if enabled
    if (taxsales > 0) {
      // totalBeforeMarginSales += parseFloat(taxsales);
      totalAfterMarginSales += parseFloat(taxsales);
    }

    setTotalCostBeforeMargin(roundToMoney(totalBeforeMarginSales));
    setTotalCostAfterMargin(roundToMoney(totalAfterMarginSales));

    setValue(
      "totalCostBeforeMarginSales",
      roundToMoney(totalBeforeMarginSales),
    );
    setValue("totalCostAfterMarginSales", roundToMoney(totalAfterMarginSales));
  };

  const isCalculating = useRef(false);

  const shipping_terms = watch("shipping_terms");

  useEffect(() => {
    if (shipping_terms === "FOB Destination") {
      setShippingHide(true);
    }
  }, [watch("shipping_terms")]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      const match = name?.match(
        /product_sales\[(\d+)\]\.(qty|cost|margin|customerCost)$/,
      );
      const otherCostMatch = name?.match(
        /other_cost_json_sales\[(\d+)\]\.Amount/,
      );

      if (match || otherCostMatch) {
        if (!isCalculating.current) {
          isCalculating.current = true;
          calculateCosts(name);
          isCalculating.current = false;
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (!isCalculating.current) {
      isCalculating.current = true;
      calculateCosts();
      isCalculating.current = false;
    }
  }, [
    watch("shippingCostsales"),
    watch("taxsales"),
    watch("product_sales"),
    watch("other_cost_json_sales"),
  ]);

  const [activeCardIndex, setActiveCardIndex] = useState(null);

  const [cardSearch, setCardSearch] = useState(
    cardFields.map(() => ({
      vendor: "",
      description: "",
      sku: "",
      showSuggestions: true,
    })),
  );

  const handleInputFocus = (index) => {
    setActiveCardIndex(index);
    const updatedCardSearch = cardSearch.map((card, idx) => {
      if (idx !== index) {
        return { ...card, showSuggestions: false };
      }
      return card;
    });
    setCardSearch(updatedCardSearch);
  };

  const handleSearchChange = (index, field, value) => {
    const vendorPartner = watch(`product_sales[${index}].vendorPartner`) || "";
    const updatedCardSearch = [...cardSearch];
    if (field === "sku") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        sku: value,
        vendor: vendorPartner,
        description: "",
        showSuggestions: true,
      };
    } else if (field === "vendor") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        vendor: value,
        sku: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "description") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        sku: "",
        vendor: "",
        description: value,
        showSuggestions: true,
      };
    }
    setCardSearch(updatedCardSearch);
  };

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );

  const onSuccessData = (data) => {
    setDataSuggetion(data);
  };

  useEffect(() => {
    const vendorPartner =
      watch(`product_sales[${activeCardIndex}].vendorPartner`) || "";
    // console.log("vendorPartner", vendorPartner);
    if (
      activeCardIndex === null ||
      !cardSearch[activeCardIndex]?.showSuggestions
    ) {
      return;
    }
    const { vendor, sku, description } = cardSearch[activeCardIndex];
    if (!vendor && !sku && !description) {
      return;
    }
    const vehicleId = watch("vehicleId");
    const contractVehicletype = watch("contractVehicletype");
    console.log("contractVehicletype", contractVehicletype);
    const requestPayload = {
      page,
      limit,
      order_status: ordertype,
      module_type: "ORDER",
      vendor: vendorPartner?.length > 0 ? vendorPartner : undefined,
      sku: sku?.length > 0 ? sku : undefined,
      description: description?.length > 0 ? description : undefined,
      is_variant: true,
    };
    if (contractVehicletype?.split(",").includes("product-bound")) {
      requestPayload.contract_type_id = vehicleId;
    }

    const debounceTimer = setTimeout(() => {
      fetchProductSearch(requestPayload, onSuccessData);
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [cardSearch, page, limit, activeCardIndex]);

  const textAreaRefs = useRef([]);
  const adjustTextAreaHeight = useCallback(
    (index) => {
      const textArea = textAreaRefs.current[index];
      if (textArea) {
        textArea.style.height = "auto";
        textArea.style.height = `${textArea.scrollHeight}px`;
      }
    },
    [textAreaRefs],
  );

  // useEffect(() => {
  //   console.log("product_sales array structure changed!");
  // }, [watch("product_sales")]);

  const handleProductSelect = useCallback(
    (product, index) => {
      const currentValues = getValues("product_sales") || [];
      const isDuplicate = currentValues.some(
        (item, idx) => item?.rowId === product?.raw_sku_id && idx !== index,
      );
      const updatedCardSearch = [...cardSearch];
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        showSuggestions: false,
      };
      setCardSearch(updatedCardSearch);
      if (isDuplicate) {
        toast.error(
          `Product with SKU ${product.sku_display_name} already exists.`,
        );
        return;
      }

      setVendorWarnings((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });

      const currentOriginalVendors = getValues("originalVendors") || {};
      setValue("originalVendors", {
        ...currentOriginalVendors,
        [index]: product?.Vendor?.display_name,
      });

      setValue(
        `product_sales[${index}].vendorPartner`,
        product?.Vendor?.display_name,
        {
          shouldValidate: true,
        },
      );

      setValue(`product_sales[${index}].vendorId`, product?.Vendor?.id, {
        shouldValidate: true,
      });

      setValue(`product_sales[${index}].productId`, product?.id, {
        shouldValidate: true,
      });

      setValue(`product_sales[${index}].skuIdUnique`, product?.sku_id, {
        shouldValidate: true,
      });

      setValue(`product_sales[${index}].skuId`, product?.sku_display_name, {
        shouldValidate: true,
      });

      setValue(`product_sales[${index}].productName`, product?.name, {
        shouldValidate: true,
      });

      const contractVehicletype = watch("contractVehicletype");
      // check if product-bound
      if (contractVehicletype?.split(",").includes("product-bound")) {
        setValue(
          `product_sales[${index}].max_quantity`,
          product?.max_quantity,
          {
            shouldValidate: true,
          },
        );
        setValue(`product_sales[${index}].rowId`, product?.raw_sku_id, {
          shouldValidate: true,
        });
      }

      setValue(
        `product_sales[${index}].skuDescription`,
        product?.description_sales,
        {
          shouldValidate: true,
        },
      );
      setValue(
        `product_sales[${index}].prodDescription`,
        product?.description,
        {
          shouldValidate: true,
        },
      );

      setValue(
        `product_sales[${index}].internalSku`,
        product?.internal_id || product?.vendor_sku || "",
        {
          shouldValidate: true,
        },
      );
      setValue(`product_sales[${index}].variantId`, product?.variant_id || "", {
        shouldValidate: true,
      });

      setValue(`product_sales[${index}].um`, product?.uoi ?? "EA", {
        shouldValidate: true,
      });

      setValue(`product_sales[${index}].type`, product?.type);

      setValue(
        `product_sales[${index}].cost`,
        trimTrailingZeros(product?.aspetto_price),
        {
          shouldValidate: true,
        },
      );
      setValue(
        `product_sales[${index}].customerCost`,
        product?.customer_price,
        {
          shouldValidate: true,
        },
      );

      if (product?.customer_price === "0.00") {
        setValue(`product_sales[${index}].margin`, "8", {
          shouldValidate: true,
        });
      }
      // setValue(`product_sales[${index}].margin`, product?.margin_percent, {
      //   shouldValidate: true,
      // });

      const textArea = textAreaRefs.current[index];
      if (textArea) {
        textArea.value = product?.description_sales;
        adjustTextAreaHeight(index);
      }
      // const updatedCardSearch = [...cardSearch];
      // updatedCardSearch[index] = {
      //     ...updatedCardSearch[index],
      //     showSuggestions: false,
      // };
      const existingRowId = getValues(`product_sales[${index}].rowId`);
      setCardSearch(updatedCardSearch);
      console.log("existingRowId", existingRowId);
      appendSkuToArray(product, 1, existingRowId);
      syncProductSalesWithCards();
      calculateCosts();
    },
    [setValue, textAreaRefs, adjustTextAreaHeight, cardSearch, setCardSearch],
  );

  useEffect(() => {
    cardFields.forEach((_, index) => {
      adjustTextAreaHeight(index);
    });
  }, [cardFields]);

  const product_sales = watch("product_sales");
  const shippingCostPurchaseNew = watch("shippingCostPurchaseNew");
  const taxPurchaseNew = watch("taxPurchaseNew");
  const otherCostPurchaseNew = watch("otherCostPurchaseNew");
  const combinedTotalCost = watch("combinedTotalCost");
  const product_purchase = getValues("cards");

  const handleLockChange = (field, index) => {
    const currentState = watch(`product_sales[${index}]`);
    if (currentState[field]) {
      setValue(`product_sales[${index}].${field}`, false);
    } else {
      // Otherwise, lock it and unlock all others
      setValue(`product_sales[${index}].CostLock`, field === "CostLock");
      setValue(`product_sales[${index}].marginLock`, field === "marginLock");
      setValue(
        `product_sales[${index}].customerCostLock`,
        field === "customerCostLock",
      );
    }
  };

  useEffect(() => {
    const base = parseFloat(totalCostBeforeMargin) || 0;
    const ship = parseFloat(shippingCostPurchaseNew) || 0;
    const t = parseFloat(taxPurchaseNew) || 0;
    const other = (otherCostPurchaseNew || []).reduce(
      (s, c) => s + (parseFloat(c?.Amount) || 0),
      0,
    );
    setValue("combinedTotalCost", roundToMoney(base + ship + t + other));
  }, [
    totalCostBeforeMargin,
    shippingCostPurchaseNew,
    taxPurchaseNew,
    otherCostPurchaseNew,
    setValue,
  ]);

  const updateTextAreaWithDescription = (index, description) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = description;
      adjustTextAreaHeight(index);
    }
  };

  const suggestionBoxRefs = useRef([]);
  const vendorSuggestionRefs = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside all suggestion boxes
      const isClickOutside = cardSearch.every((_, index) => {
        const suggestionBox = suggestionBoxRefs.current[index];
        return suggestionBox && !suggestionBox.contains(event.target);
      });

      if (isClickOutside) {
        // Close all suggestion boxes and clear suggestions
        setDataSuggetion(null);
        setCardSearch((prev) =>
          prev.map((card) => ({
            ...card,
            showSuggestions: false,
          })),
        );
      }

      const isVendorOutside = vendorSuggestionRefs.current.every((box) =>
        box ? !box.contains(event.target) : true,
      );

      if (isVendorOutside) {
        setSuggestionData([]);
        setSearchDebounces({ searchName: "" });
      }
    };

    // Add event listener for mousedown
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cardSearch]);

  const handleMarginChange = (index, marginValue) => {
    setValue(`product_sales[${index}].margin`, marginValue, {
      shouldValidate: true,
    }); // Update the form value
    // If margin is less than 8%, set the warning for that specific index
    setMarginWarnings((prevWarnings) => ({
      ...prevWarnings,
      [index]: parseFloat(marginValue) < 8,
    }));
  };

  const handleQtyChange = (index, newQty) => {
    const skuIdUnique = getValues(`product_sales[${index}].rowId`);
    if (!skuIdUnique) return;
    console.log("setSkuIdssetSkuIds", skuIds);
    console.log("skuIdUniqueskuIdUnique", skuIdUnique);

    // new added to track the qty change
    setChangeTracking({
      raw_sku_id: skuIdUnique,
      change_type: "qty",
    });

    setSkuIds((prev) =>
      prev.map((item) =>
        item.raw_sku_id === skuIdUnique
          ? { ...item, qty: Number(newQty) || 1 }
          : item,
      ),
    );

    console.log("the handle qty was triggered");

    // setTimeout(() => {
    //   triggerPurchaseDataFetch();
    // }, 300);
  };

  const handleProductsClick = (autoId) => {
    console.log("this is triggered");
    setShowFbopPopup(false);
    setSelectedAutoId(autoId);
    setShowPdfProductsPopup(true);
  };

  return (
    <>
      <FbopPdfPopup
        show={showFbopPopup}
        onClose={() => setShowFbopPopup(false)}
        onProductsClick={handleProductsClick}
      />
      <PdfProductsPopup
        show={showPdfProductsPopup}
        onClose={() => setShowPdfProductsPopup(false)}
        autoId={selectedAutoId}
        onSubmitSuccess={handleAddSkuBulk}
      />
      {showModal && (
        <SearchPopUpSales
          syncProductSalesWithCards={syncProductSalesWithCards}
          calculateCosts={calculateCosts}
          order_ref_type={order_ref_type}
          ordertype={ordertype}
          show={showModal}
          searchProps={searchProps}
          setSearchProps={setSearchProps}
          setShow={setShowModal}
          onAddSku={handleAddSku}
          setCardSearch={setCardSearch}
          cardSearch={cardSearch}
          updateTextArea={updateTextAreaWithDescription}
          searchType={searchType}
          appendSkuToArray={appendSkuToArray}
        />
      )}
      <div className="drag_section">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable-cards">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {cardFields.map((card, index) => (
                  <Draggable
                    key={card.id}
                    draggableId={`card-${index}`}
                    index={index}
                  >
                    {(provided) => (
                      <Card
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="mb-3"
                      >
                        <Card.Body>
                          <div className="grag_flex_row">
                            <Col className="drag_icon_set">
                              <div
                                className="drag_icon_group trash_icon"
                                {...provided.dragHandleProps}
                              >
                                {cardFields.length > 1 && (
                                  <IconTrash
                                    onClick={() => handleRemoveCard(index)}
                                  />
                                )}
                                <IconArrowsUpDown style={{ cursor: "move" }} />
                              </div>
                            </Col>
                            <input
                              type="hidden"
                              {...register(`product_sales[${index}].variantId`)}
                            />
                            <Form.Control
                              {...register("hasKitProducts")}
                              type="hidden"
                            />
                            <div className="drag_fields_grid">
                              <div className="drag_fields_left">
                                <div>
                                  <Form.Group>
                                    <Form.Label className="required">
                                      VENDOR NAME
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `product_sales[${index}].vendorPartner`,
                                        )}
                                        disabled={
                                          order_ref_type === "project" ||
                                          !canEditProducts
                                        }
                                        defaultValue={card.vendorPartner}
                                        placeholder="Enter Name"
                                        // value={cardSearch[activeCardIndex]?.vendor || ""}
                                        onChange={handleSearchByName}
                                        // onChange={(e) =>
                                        //   handleSearchChange(
                                        //     activeCardIndex,
                                        //     "vendor",
                                        //     e.target.value
                                        //   )
                                        // }
                                        onFocus={() => handleInputFocus(index)}
                                      />
                                    </InputGroup>
                                    <div>
                                      {index === activeCardIndex &&
                                        suggestionData?.data?.length > 0 &&
                                        searchDebounces?.searchName?.length >
                                          0 && (
                                          <div
                                            className="suggestions_box"
                                            ref={(el) =>
                                              (vendorSuggestionRefs.current[
                                                index
                                              ] = el)
                                            }
                                          >
                                            <div className="table-responsive">
                                              <Table>
                                                <tbody>
                                                  {suggestionData?.data?.map(
                                                    (item, idx) => (
                                                      <tr
                                                        key={idx}
                                                        onClick={() =>
                                                          handleSelectVendor(
                                                            item,
                                                            index,
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        <td>
                                                          {item?.display_name}
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </tbody>
                                              </Table>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                    {errors?.product_sales?.[index]
                                      ?.vendorPartner && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].vendorPartner.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>

                                <div className="">
                                  <Form.Group>
                                    <Form.Label className="">
                                      PRODUCT NAME
                                    </Form.Label>
                                    <InputGroup>
                                      <TruncatedTooltip>
                                        <Form.Control
                                          {...register(
                                            `product_sales[${index}].productName`,
                                          )}
                                          placeholder="Product Name"
                                          disabled={!canEditProducts}
                                        />
                                      </TruncatedTooltip>
                                    </InputGroup>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group>
                                    <Form.Label>INTERNAL SKU</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `product_sales[${index}].internalSku`,
                                        )}
                                        placeholder="Internal SKU"
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>

                                <div>
                                  <Form.Group>
                                    <Form.Label className="required">
                                      VENDOR SKU
                                    </Form.Label>
                                    <InputGroup>
                                      <TruncatedTooltip>
                                        <Form.Control
                                          disabled={
                                            order_ref_type === "project" ||
                                            !canEditProducts
                                          }
                                          {...register(
                                            `product_sales[${index}].skuId`,
                                          )}
                                          // value={watch(`cards[${index}].skuId`)}
                                          placeholder="VENDOR SKU"
                                          defaultValue={card.skuId}
                                          onChange={(e) =>
                                            handleSearchChange(
                                              activeCardIndex,
                                              "sku",
                                              e.target.value,
                                            )
                                          }
                                          onFocus={() =>
                                            handleInputFocus(index)
                                          }
                                        />
                                      </TruncatedTooltip>
                                    </InputGroup>
                                    {errors?.product_sales?.[index]?.skuId && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].skuId.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>

                              <div className="drag_fields_center">
                                <Form.Group
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                  }}
                                >
                                  <Form.Label className="required">
                                    SKU DESCRIPTION
                                  </Form.Label>
                                  <InputGroup>
                                    <Controller
                                      control={control}
                                      name={`product_sales[${index}].skuDescription`}
                                      defaultValue={card.skuDescription || ""}
                                      // defaultValue={
                                      //   ["M", "CRK", "DS", "S"].includes(
                                      //     ordertype,
                                      //   )
                                      //     ? card.skuDescription &&
                                      //       card.skuDescription.trim() !== ""
                                      //       ? card.skuDescription
                                      //       : card.prodDescription
                                      //     : card.skuDescription
                                      // }
                                      render={({ field }) => (
                                        <Form.Control
                                          {...field}
                                          as="textarea"
                                          rows={1}
                                          disabled={
                                            order_ref_type === "project" ||
                                            !canEditProducts
                                          }
                                          placeholder="Description"
                                          style={{
                                            resize: "none",
                                            overflow: "hidden",
                                          }}
                                          ref={(el) => {
                                            field.ref(el);
                                            textAreaRefs.current[index] = el;
                                          }}
                                          onChange={(e) => {
                                            field.onChange(e);

                                            const value = e.target.value;

                                            handleSearchChange(
                                              index,
                                              "description",
                                              value,
                                            );

                                            handleDescriptionChange(
                                              index,
                                              value,
                                            );
                                          }}
                                          onFocus={() =>
                                            handleInputFocus(index)
                                          }
                                        />
                                      )}
                                    />
                                  </InputGroup>
                                  {errors?.product_sales?.[index]
                                    ?.skuDescription && (
                                    <span className="text-danger">
                                      {/* {errors.cards[index].skuDescription.message} */}
                                    </span>
                                  )}
                                </Form.Group>
                              </div>
                              <div className="drag_fields_right">
                                <div>
                                  <Form.Group>
                                    <Form.Label className="required">
                                      QTY
                                    </Form.Label>
                                    <InputGroup>
                                      {/*   <Form.Control
                                    type="number"
                                    step="any"
                                    onKeyDown={handleKeyDown}
                                    {...register(
                                      `product_sales[${index}].qty`,
                                      {
                                        required: "Quantity is required",
                                        pattern: {
                                          value: /^[0-9]+$/,
                                          message: "Quantity must be a number",
                                        },
                                      }
                                    )}
                                    // onBlur={() => {
                                    //   syncProductSalesWithCards();
                                    // }}
                                    defaultValue={card.qty}
                                    placeholder="0"
                                  /> */}
                                      <Form.Control
                                        type="text"
                                        step="any"
                                        onKeyDown={handleKeyDown}
                                        defaultValue={card.qty}
                                        disabled={!canEditProducts}
                                        placeholder="0"
                                        {...register(
                                          `product_sales[${index}].qty`,
                                          {
                                            required: "Quantity is required",
                                            pattern: {
                                              value: /^[0-9]+$/,
                                              message:
                                                "Quantity must be a number",
                                            },
                                          },
                                        )}
                                        onChange={(e) => {
                                          const value = Number(e.target.value);
                                          const values = getValues(
                                            `product_sales[${index}]`,
                                          );
                                          const maxQty = values?.max_quantity;
                                          if (maxQty && value > maxQty) {
                                            toast.error(
                                              `Maximum allowed quantity is ${maxQty}`,
                                            );
                                            // Optionally reset to maxQty or previous value
                                            setValue(
                                              `product_sales[${index}].qty`,
                                              maxQty || card.qty,
                                              {
                                                shouldValidate: true,
                                              },
                                            );
                                          } else {
                                            setValue(
                                              `product_sales[${index}].qty`,
                                              value,
                                              {
                                                shouldValidate: true,
                                              },
                                            );
                                          }
                                          // handleQtyChange(index, value);
                                        }}
                                        onBlur={(e) =>
                                          handleQtyChange(index, e.target.value)
                                        }
                                        // onChange={(e) => {
                                        //   const value = Number(e.target.value);
                                        //   const values = getValues(
                                        //     `product_sales[${index}]`
                                        //   );
                                        //   const maxQty = values?.max_quantity;
                                        //   if (value > maxQty) {
                                        //     toast.error(
                                        //       `Maximum allowed quantity is ${maxQty}`
                                        //     );
                                        //   }
                                        // }}
                                      />
                                    </InputGroup>
                                    {errors?.product_sales?.[index]?.qty && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].qty.message} */}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>
                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label className="required">
                                      Cost
                                    </Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconCurrencyDollar stroke={2} />
                                      </InputGroup.Text>

                                      <Form.Control
                                        type="text"
                                        onKeyDown={handleKeyDown}
                                        step="any"
                                        {...register(
                                          `product_sales[${index}].cost`,
                                          {
                                            required: "Cost is required",
                                            pattern: {
                                              value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                              message: "Enter a valid cost",
                                            },
                                          },
                                        )}
                                        defaultValue={card.cost}
                                        placeholder="Enter Cost"
                                        // disabled={watch(`cards[${index}].CostLock`)}
                                        disabled={
                                          watch(
                                            `product_sales[${index}].CostLock`,
                                          ) ||
                                          order_ref_type === "project" ||
                                          !canEditProducts
                                        }
                                        onBlur={(e) =>
                                          handleCostChange(
                                            index,
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </InputGroup>
                                    {errors?.product_sales?.[index]?.cost && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].cost.message} */}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                        id={`lock-toggle-${index}`}
                                        step="any"
                                        label={
                                          <>
                                            {watch(
                                              `product_sales[${index}].CostLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `product_sales[${index}].CostLock`,
                                        )}
                                        checked={watch(
                                          `product_sales[${index}].CostLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange("CostLock", index)
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>
                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label className="required">
                                      Margin
                                    </Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconPercentage stroke={2} />
                                      </InputGroup.Text>

                                      <Form.Control
                                        // onKeyDown={handleKeyDown}
                                        type="text"
                                        step="any"
                                        {...register(
                                          `product_sales[${index}].margin`,
                                          {
                                            required: "Margin is required",
                                          },
                                        )}
                                        onChange={(e) => {
                                          handleMarginChange(
                                            index,
                                            e.target.value,
                                          );
                                          // handleMarginChangeWithFetch(index, e.target.value);
                                        }}
                                        defaultValue={card.margin}
                                        placeholder="0.00"
                                        disabled={
                                          watch(
                                            `product_sales[${index}].marginLock`,
                                          ) ||
                                          order_ref_type === "project" ||
                                          !canEditProducts
                                        }
                                        // onBlur={() => {
                                        //   syncProductSalesWithCards();
                                        // }}
                                      />
                                    </InputGroup>
                                    {errors?.product_sales?.[index]?.margin && (
                                      <span className="text-danger">
                                        {
                                          errors.product_sales[index].margin
                                            .message
                                        }
                                      </span>
                                    )}

                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                        id={`margin-lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `product_sales[${index}].marginLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `product_sales[${index}].marginLock`,
                                        )}
                                        checked={watch(
                                          `product_sales[${index}].marginLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange("marginLock", index)
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>
                                <div>
                                  <Form.Group className="lock_group">
                                    <Form.Label>Price</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconCurrencyDollar stroke={2} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        step="any"
                                        onKeyDown={handleKeyDown}
                                        {...register(
                                          `product_sales[${index}].customerCost`,
                                          {
                                            required:
                                              "Customer's price is required",
                                            pattern: {
                                              value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                              message:
                                                "Enter a valid customer cost",
                                            },
                                          },
                                        )}
                                        defaultValue={card.customerCost}
                                        placeholder="Customer's Cost"
                                        disabled={
                                          watch(
                                            `product_sales[${index}].customerCostLock`,
                                          ) ||
                                          order_ref_type === "project" ||
                                          !canEditProducts
                                        }
                                        checked={watch(
                                          `product_sales[${index}].customerCostLock`,
                                        )}
                                        // onChange={(e) => handleCustomerCostChange(index, e.target.value)}
                                      />
                                    </InputGroup>
                                    {errors?.product_sales?.[index]
                                      ?.customerCost && (
                                      <span className="text-danger">
                                        {/* {errors.cards[index].customerCost.message} */}
                                      </span>
                                    )}
                                    <span className="lock_unlock">
                                      <Form.Check
                                        type="switch"
                                        id={`customer-cost-lock-toggle-${index}`}
                                        label={
                                          <>
                                            {watch(
                                              `product_sales[${index}].customerCostLock`,
                                            ) ? (
                                              <IconLock stroke={1} />
                                            ) : (
                                              <IconLockOpen2 stroke={1} />
                                            )}
                                          </>
                                        }
                                        {...register(
                                          `product_sales[${index}].customerCostLock`,
                                        )}
                                        checked={watch(
                                          `product_sales[${index}].customerCostLock`,
                                        )}
                                        onChange={() =>
                                          handleLockChange(
                                            "customerCostLock",
                                            index,
                                          )
                                        }
                                      />
                                    </span>
                                  </Form.Group>
                                </div>
                                <div className="drag_fields_right_row2">
                                  <div>
                                    <Form.Group>
                                      <Form.Label className="">CLIN</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          // onKeyDown={handleKeyDown}
                                          step="any"
                                          {...register(
                                            `product_sales[${index}].clin`,
                                          )}
                                          placeholder="CLIN"
                                          disabled={!canEditProducts}
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.clin && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].clin.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>
                                  <div>
                                    <Form.Group>
                                      <Form.Label>UM</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          {...register(
                                            `product_sales[${index}].um`,
                                          )}
                                          disabled={
                                            order_ref_type === "project" ||
                                            !canEditProducts
                                          }
                                          defaultValue={card.um}
                                          placeholder="EA"
                                        />
                                      </InputGroup>
                                      {errors?.product_sales?.[index]?.um && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].qty.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>

                                  <div>
                                    <Form.Group>
                                      <Form.Label>Total Price</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconCurrencyDollar stroke={2} />
                                        </InputGroup.Text>
                                        <Form.Control
                                          readOnly
                                          type="text"
                                          step="any"
                                          onKeyDown={handleKeyDown}
                                          {...register(
                                            `product_sales[${index}].totalSkuCost`,
                                            {
                                              required:
                                                "Total price is required",
                                              pattern: {
                                                value:
                                                  /^[0-9]+(\.[0-9]{1,2})?$/,
                                                message:
                                                  "Enter a valid total price",
                                              },
                                            },
                                          )}
                                          defaultValue={card.totalSkuCost}
                                          disabled={
                                            order_ref_type === "project"
                                          }
                                          placeholder="Total Price"
                                        />
                                      </InputGroup>
                                      {errors?.product_sales?.[index]
                                        ?.totalSkuCost && (
                                        <span className="text-danger">
                                          {
                                            errors.product_sales[index]
                                              .totalSkuCost.message
                                          }
                                        </span>
                                      )}
                                    </Form.Group>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {showSkuId && (
                              <>
                                <Col className="mid_drag_column mob_50">
                                  <Form.Group>
                                    <Form.Label className="required">
                                      PRODUCT ID
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `product_sales[${index}].productId`,
                                        )}
                                        placeholder="PRODUCT ID"
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                                <Col className="mid_drag_column mob_50">
                                  <Form.Group>
                                    <Form.Label className="required">
                                      VENDOR ID
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `product_sales[${index}].vendorId`,
                                        )}
                                        placeholder="VENDOR ID"
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                                <Col className="mid_drag_column mob_50">
                                  <Form.Group>
                                    <Form.Label className="required">
                                      TYPE
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `product_sales[${index}].type`,
                                        )}
                                        placeholder="TYPE"
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                                <Col className="mid_drag_column mob_50">
                                  <Form.Group>
                                    <Form.Label className="required">
                                      UNIQUE SKU ID
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `product_sales[${index}].skuIdUnique`,
                                        )}
                                        placeholder="SKU ID"
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                                <div className="mid_drag_column mob_50">
                                  <Form.Group>
                                    <Form.Label className="">ROW ID</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        {...register(
                                          `product_sales[${index}].rowId`,
                                        )}
                                        placeholder="SKU ID"
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </div>
                                <Col className="mob_50">
                                  <Form.Group className="lock_group">
                                    <Form.Label>Purchase Price</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <IconCurrencyDollar stroke={2} />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="text"
                                        step="any"
                                        onKeyDown={handleKeyDown}
                                        {...register(
                                          `product_sales[${index}].purchaseCost`,
                                        )}
                                        defaultValue={card.purchaseCost}
                                        placeholder="Customer's Cost"
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                              </>
                            )}
                          </div>
                          <div className="text-danger text-end mt-2">
                            {marginWarnings[index] && (
                              <div className="mb-1">
                                Margins below 12% aren't recommended. Click
                                "Next" to confirm this is intentional.
                              </div>
                            )}
                          </div>
                          <div className="text-danger text-start mt-2">
                            {vendorWarnings[index] && (
                              <div>
                                This name does not match the master vendor. If
                                it’s intentional, hit next to proceed.
                              </div>
                            )}
                          </div>
                          {/* {marginWarnings[index] && (
                            <div className="text-danger text-end">
                              Margins below 12% aren't recommended. Click "Next"
                              to confirm this is intentional.
                            </div>
                          )} */}

                          {cardSearch[index]?.showSuggestions &&
                            (cardSearch[index]?.vendor ||
                              cardSearch[index]?.sku ||
                              cardSearch[index]?.description) &&
                            dataSuggetion?.data?.length > 0 && (
                              <div
                                className="suggestions_box"
                                ref={(el) =>
                                  (suggestionBoxRefs.current[index] = el)
                                }
                              >
                                <div className="table-responsive">
                                  <Table>
                                    <tbody>
                                      {dataSuggetion.data.map(
                                        (product, idx) => (
                                          <tr
                                            key={idx}
                                            onClick={() =>
                                              handleProductSelect(
                                                product,
                                                index,
                                              )
                                            }
                                          >
                                            <td>
                                              {product?.Vendor?.display_name}
                                            </td>
                                            <td>{product?.sku_display_name}</td>
                                            <td>{product?.name}</td>
                                            <td>
                                              {" "}
                                              {trimText(
                                                product?.description_sales,
                                                100,
                                              )}
                                            </td>
                                            <td>{product?.uoi}</td>
                                            <td>
                                              $
                                              {trimTrailingZeros(
                                                product?.aspetto_price,
                                              )}
                                            </td>
                                            <td>{product?.margin_percent}%</td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                                <div className="text-center">
                                  <Button
                                    variant="link"
                                    className="see-all-btn p-1"
                                    onClick={() =>
                                      handleOpenModal(index, "sku")
                                    }
                                  >
                                    See All SKUs <IconArrowNarrowRight />
                                  </Button>
                                </div>
                              </div>
                            )}
                        </Card.Body>
                      </Card>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          {/* {order_ref_type === "project" ? null : ( */}
          <div className="add_remove_sku mb-3">
            <p className="text-center mb-2">Product Items (SKUs)</p>
            <div className="btn_group_sku">
              <Button
                variant=""
                className="add_sku_button"
                onClick={handleAddCard}
                disabled={!canEditProducts}
              >
                <IconPlus /> BLANK PRODUCT
              </Button>
              <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "skuAll")}
                disabled={!canEditProducts}
              >
                <IconSearch /> PRODUCTS LIBRARY
              </Button>
              <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "contract")}
                disabled={!canEditProducts}
              >
                <IconSearch /> CONTRACT VEHICLE LIBRARY
              </Button>

              <Button
                variant=""
                className="add_sku_button"
                onClick={() => setShowFbopPopup(true)}
                disabled={!canEditProducts}
              >
                <IconSearch /> VALIDATED FORMS
              </Button>
            </div>
          </div>
        </DragDropContext>
      </div>
      <div>
        <Card.Body>
          <Row></Row>
          <Row className={`mb-2 ${shippingHide ? "d-none" : ""}`}>
            <div className="d-flex align-items-center gap-2 costing_rows mb-2">
              <Form.Check
                aria-label="option 1"
                className="d-flex align-items-center"
                disabled={!canEditProducts}
              />
              <Form.Check.Label>
                Do not reduce project total budget
              </Form.Check.Label>
            </div>

            <div className="costing_rows p-0">
              <Form.Check
                className="ps-0 pe-2"
                type="switch"
                label="Customer Shipping Charge"
                {...register("shippingCostEnabledsales")}
                disabled={order_ref_type === "project"}
                checked={getValues("shippingCostEnabledsales")}
                onChange={(e) =>
                  setValue("shippingCostEnabledsales", e.target.checked)
                }
              />

              <div className="costing_input">
                <Form.Group>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCurrencyDollar stroke={2} />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      step="any"
                      onKeyDown={handleKeyDown}
                      {...register("shippingCostsales", {
                        required: watch("shippingCostEnabledsales")
                          ? "Customer Shipping Charge is required"
                          : false,
                        // pattern: {
                        //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                        //   message: "Enter a valid shipping cost",
                        // },
                      })}
                      disabled={
                        !watch("shippingCostEnabledsales") ||
                        order_ref_type === "project" ||
                        !canEditProducts
                      }
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </Row>

          <Row className="mb-2">
            <div className="costing_rows p-0">
              <Form.Check
                className="ps-0 pe-2"
                type="switch"
                label="Tax"
                {...register("taxEnabledsales")}
                checked={getValues("taxEnabledsales")}
                onChange={(e) => setValue("taxEnabledsales", e.target.checked)}
              />

              <div className="costing_input">
                <Form.Group>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCurrencyDollar />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      step="any"
                      // defaultValue={0.00}
                      onKeyDown={handleKeyDown}
                      {...register("taxsales", {
                        required: watch("taxEnabledsales")
                          ? "Tax is required"
                          : false,
                        // pattern: {
                        //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                        //   message: "Enter a valid tax amount",
                        // },
                      })}
                      placeholder="0.00"
                      disabled={
                        !watch("taxEnabledsales") ||
                        order_ref_type === "project" ||
                        !canEditProducts
                      }
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </Row>

          <Row className="mb-2 justify-content-end">
            {otherCostFields.map((item, index) => (
              <Row className="mb-2" key={item.id}>
                <div className="costing_rows p-0">
                  <div className="costing_input">
                    <span
                      className="trash_icon"
                      onClick={() => handleRemoveOthercost(index)}
                    >
                      <IconTrash />
                    </span>
                    <Form.Group>
                      <InputGroup className="costing_name">
                        <Form.Control
                          {...register(`other_cost_json_sales[${index}].Name`)}
                          placeholder="Enter Cost Name"
                          disabled={order_ref_type === "project"}
                        />
                      </InputGroup>
                      {errors?.other_cost_json_sales?.[index]?.Name && (
                        <span className="text-danger">
                          {/* {errors.cards[index].vendorPartner.message} */}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group>
                      <InputGroup className="costing_amount">
                        <InputGroup.Text>
                          <IconCurrencyDollar />
                        </InputGroup.Text>
                        <Form.Control
                          type="number"
                          step="any"
                          {...register(
                            `other_cost_json_sales[${index}].Amount`,
                            {
                              required: "Amount is required",
                              pattern: {
                                value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                message: "Enter a valid amount",
                              },
                            },
                          )}
                          placeholder="Amount"
                          disabled={order_ref_type === "project"}
                        />
                      </InputGroup>

                      {errors?.other_cost_json_sales?.[index]?.Amount && (
                        <span className="text-danger">
                          {/* {errors.cards[index].vendorPartner.message} */}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </div>
              </Row>
            ))}

            {order_ref_type === "project" ? null : (
              <div className="costing_rows p-0">
                <Button
                  variant=""
                  className="add_sku_button w-auto"
                  onClick={handleAddOtherCost}
                  disabled={order_ref_type === "project" || !canEditProducts}
                >
                  <IconPlus /> OTHER COST
                </Button>
              </div>
            )}
          </Row>

          <div className="totle_costing mt-3">
            <h6>
              Total Cost:{" "}
              <span>
                <IconCurrencyDollar />
                {/* {["M", "CRK", "DS", "S"].includes(ordertype) &&
                combinedTotalCost != null
                  ? combinedTotalCost
                  : totalCostBeforeMargin} */}
                {totalCostBeforeMargin}
              </span>
            </h6>

            <Form.Control
              {...register("totalCostBeforeMargin")}
              // value={
              //   ["M", "CRK", "DS", "S"].includes(ordertype) &&
              //   combinedTotalCost != null
              //     ? combinedTotalCost
              //     : totalCostBeforeMargin
              // }
              value={totalCostBeforeMargin}
              readOnly
              type="hidden"
              placeholder="Total Cost"
            />
          </div>

          <div className="totle_costing">
            <h6>
              Total Price:{" "}
              <span>
                <IconCurrencyDollar />
                {totalCostAfterMargin}
              </span>
            </h6>

            <Form.Control
              {...register("totalCostAfterMargin")}
              value={totalCostAfterMargin}
              readOnly
              type="hidden"
              placeholder="Total Price"
            />
          </div>
        </Card.Body>
      </div>
    </>
  );
}

export default ProductsSales;
